import * as NotesActions from "./notesActions";

export default NotesActions;



// WEBPACK FOOTER //
// ./src/actions/NotesActions/index.js